// @ts-check
import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useDispatch } from 'react-redux';
import {
	actions as userDetailsActions,
	moduleKeys as userDetailsModuleKeys,
} from 'modules/api/account/user/detailsModule';
import { actions as accountDetailActions } from 'modules/api/account/detailsModule';
import { oidcActions } from './redux';
import {
	useAuthenticated,
	useBasketAdmin,
	useKeroOnly,
} from './useAuthenticated';
import useLogin from './useLogin';

/** @deprecated just until we get sagas retired */
export const oidcContext = {};

/** @deprecated just until we get sagas retired */
export const oidcLoginRef = {
	current: /** @type {ReturnType<useLogin>} */ () => Promise.reject(),
};

export function ReduxConnector() {
	const dispatch = useDispatch();
	const context = useAuth();
	const { user, isLoading } = context;
	const isAuthenticated = useAuthenticated();
	const isBasketAdmin = useBasketAdmin();
	const isKeroOnly = useKeroOnly();

	// Expose functions directly to sagas
	Object.assign(oidcContext, context);
	oidcLoginRef.current = useLogin();

	// Copy user to redux
	useEffect(() => {
		dispatch(oidcActions.setUser(user));
	}, [dispatch, user]);

	// Copy user state to redux
	useEffect(() => {
		dispatch(oidcActions.setAuthenticated(isAuthenticated));
	}, [dispatch, isAuthenticated]);

	// Copy loading status to redux
	useEffect(() => {
		dispatch(oidcActions.setLoading(isLoading));
	}, [dispatch, isLoading]);

	// When Logged in
	useEffect(() => {
		if (isLoading) return;
		const username = user?.profile?.username;
		if (!isAuthenticated || isBasketAdmin || !username) return;

		dispatch(
			userDetailsActions.fetch(
				{ username },
				userDetailsModuleKeys.LOGGED_IN_USER,
			),
		);

		dispatch(
			accountDetailActions.fetch({
				alsowith: [
					'businessUnit',
					'customerLifecycle',
					'highlights',
					'managementPortal',
					'referAFriend',
				],
			}),
		);
	}, [dispatch, isLoading, isAuthenticated, isBasketAdmin, user]);

	// Emulate old oidc actions
	useEffect(() => {
		if (isLoading) return;
		dispatch({
			type: isAuthenticated ? oidcActions.USER_FOUND : oidcActions.USER_EXPIRED,
			isBasketAdmin,
			isKeroOnly,
		});
	}, [isLoading, dispatch, isAuthenticated, isBasketAdmin, isKeroOnly]);

	return null;
}

export default ReduxConnector;
